/** Money maths for the cash drawer, done in whole pence so 0.1 + 0.2 never bites. */

export function toPence(amount: number): number {
  if (!Number.isFinite(amount)) return 0;
  return Math.round(amount * 100);
}

export function fromPence(pence: number): number {
  return pence / 100;
}

/** Change to hand back; never negative. */
export function changeDue(total: number, tendered: number): number {
  return fromPence(Math.max(0, toPence(tendered) - toPence(total)));
}

/** The next multiple of `stepPounds` strictly above `pence`. */
const nextAbove = (pence: number, stepPounds: number): number => {
  const step = stepPounds * 100;
  return (Math.floor(pence / step) + 1) * step;
};

/**
 * Quick-tender buttons: the exact amount, then the next round £5, £10 and £20 strictly above
 * it. De-duplicated and ascending, e.g. 23.40 -> [23.40, 25, 30, 40]; 20 -> [20, 25, 30, 40].
 */
export function quickTenderAmounts(total: number): number[] {
  const totalPence = toPence(total);
  if (totalPence <= 0) return [];

  const candidates = [totalPence, nextAbove(totalPence, 5), nextAbove(totalPence, 10), nextAbove(totalPence, 20)];
  const unique = Array.from(new Set(candidates)).sort((a, b) => a - b);

  return unique.map(fromPence);
}
